import { create } from "zustand";
import { IssueTypeEnum } from "@/__generated__/graphql";
import { usePackageIssueDetailsStore } from "./issueDetails";

export enum PackageIssueType {
  editAddress = "editAddress",
  modifyPlan = "modifyPlan",
  cancelPackage = "cancelPackage",
}

type PackageIssueState = {
  showModal: boolean;
  issueType: PackageIssueType | null;
  packageId: string | null;
};

type PackageIssueStore = {
  data: PackageIssueState;
  openPackageIssueModal(issueType: PackageIssueType, packageId: string): void;
  closePackageIssueModal(): void;
};

const initialData: PackageIssueState = {
  showModal: false,
  issueType: null,
  packageId: null,
};

export const usePackageIssueStore = create<PackageIssueStore>((set, get) => ({
  data: initialData,
  openPackageIssueModal: (issueType: PackageIssueType, packageId: string) => {
    set({
      data: {
        ...get().data,
        showModal: true,
        issueType,
        packageId,
      },
    });

    let type: IssueTypeEnum;

    switch (issueType) {
      case PackageIssueType.editAddress:
        type = IssueTypeEnum.PackageUpdateAddress;
        break;
      case PackageIssueType.modifyPlan:
        type = IssueTypeEnum.PackageUpdate;
        break;
      default:
        type = IssueTypeEnum.PackageTermination;
        break;
    }

    usePackageIssueDetailsStore.getState().fetch({
      requestPayload: {
        type,
      },
    });
  },
  closePackageIssueModal: () => {
    set({
      data: initialData,
    });
  },
}));
